<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <CreateTaskContent />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import CreateTaskContent from "./components/CreateTaskContent.vue";

export default {
  components: {
    PageHeaderLayout,
    CreateTaskContent,
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  padding: 20px 40px 20px 20px;
}
</style>
